/**
 * Workspace logo, brand colour, login background, and default theme.
 * Owner and admin only on write; the backend answers 403 for a member.
 */

import type { CompanyApi } from "../../hooks/useCompanyApi"
import { unwrap } from "./errors.ts"

export interface ICompanyBranding {
  logoUrl: string | null
  brandColor: string | null
  loginBackgroundUrl: string | null
  defaultTheme: string | null
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

function stringOrNull(value: unknown): string | null {
  return typeof value === "string" ? value : null
}

function readBranding(payload: unknown): ICompanyBranding {
  const envelope = isRecord(payload) && "data" in payload ? payload.data : payload
  const body = isRecord(envelope) ? envelope : {}
  return {
    logoUrl: stringOrNull(body.logoUrl),
    brandColor: stringOrNull(body.brandColor),
    loginBackgroundUrl: stringOrNull(body.loginBackgroundUrl),
    defaultTheme: stringOrNull(body.defaultTheme),
  }
}

export async function fetchCompanyBranding(company: CompanyApi): Promise<ICompanyBranding> {
  const response = unwrap(await company.branding.get())
  return readBranding(response)
}

export async function updateCompanyBranding(company: CompanyApi, body: ICompanyBranding): Promise<ICompanyBranding> {
  const response = unwrap(await company.branding.put(body))
  return readBranding(response)
}
